import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const GlobalUserActions = require('../../actions/GlobalUserActions');
const GlobalUserStore = require('../../stores/GlobalUserStore');
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    id: PropTypes.number.isRequired
};

const defaultProps = {};

export default function withGlobalUserInfo(WrappedComponent) {
    class WithGlobalUserInfo extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                globalUserStoreState: GlobalUserStore.getState(),
                getActionId: null
            }

            this.unsubscribes = [
                GlobalUserStore.listen(this.onGlobalUserStoreStateChange.bind(this))
            ];
        }

        componentDidMount() {
            if (typeof this.props.id !== 'number') {
                console.warn(`WithGlobalUserInfo - Invalid user id: ${this.props.id}`);
                return;
            }

            if (!this.state.globalUserStoreState.users[this.props.id]) {
                const actionId = uuid.v4();
                this.setState({ getActionId: actionId }, () => {
                    GlobalUserActions.getInfo(actionId, { id: this.props.id });
                });
            }
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        onGlobalUserStoreStateChange(state) {
            let additionalState = {};
            if (state.action.id === this.state.getActionId) {
                additionalState = { ...additionalState, getActionId: null };
            }

            this.setState({ globalUserStoreState: state, ...additionalState });
        }

        render() {
            const user = this.state.globalUserStoreState.users[this.props.id];
            if (!user) {
                return null;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    user={user}
                />
            );
        }
    }

    WithGlobalUserInfo.propTypes = propTypes;
    WithGlobalUserInfo.defaultProps = defaultProps;
    WithGlobalUserInfo.displayName = `WithGlobalUserInfo(${ReactUtil.getComponentDisplayName(WrappedComponent)})`;
    return WithGlobalUserInfo;
}